import { Route, Routes } from "react-router-dom";
import OrderDetails from "./orders/OrderDetails";
import OrdersList from "./orders/OrdersList";
import OrderItem from "./orders/OrderItem";
import LeaveReview from "./orders/LeaveReview";
import ReturnItem from "./orders/ReturnItem";

const Orders = () => {
  return (
    <div>
      {/* <ScrollRestoration /> */}
      <Routes>
        <Route path="/" element={<OrdersList />} />
        <Route path=":orderId" element={<OrderDetails />} />
        <Route path=":orderId/item/:itemId" element={<OrderItem />} />
        <Route path=":orderId/item/:itemId/review" element={<LeaveReview />} />
        <Route path=":orderId/item/:itemId/return" element={<ReturnItem />} />
      </Routes>
    </div>
  );
};

export default Orders;
